"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleInstance = exports.ModuleSchema = void 0;
const zod_1 = require("zod");
const zod_partial_1 = require("../../Utils/zod-partial");
const metadata_1 = require("../metadata");
const ColorOverride_1 = require("./ColorOverride");
const ModuleDrawProperty_1 = require("./ModuleDrawProperty");
const ModuleTransform_1 = require("./ModuleTransform");
const XYPosition_1 = require("./XYPosition");
const ProjectDataTypeInstance_1 = require("../ProjectInstances/ProjectDataTypeInstance");
exports.ModuleSchema = zod_1.z.object({
    ref: zod_1.z.string(),
    footprintRef: zod_1.z.string(),
    componentRef: zod_1.z.string(),
    center: XYPosition_1.XYPositionSchema,
    layer: zod_1.z.enum(['F', 'B']),
    transform: ModuleTransform_1.ModuleTransformSchema,
    name: zod_1.z.string(),
    fullModuleName: zod_1.z.string().optional(),
    pinNets: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    drawProperties: zod_1.z.record(zod_1.z.string(), ModuleDrawProperty_1.ModuleDrawPropertySchema),
    metadata: metadata_1.MetadataSchema.optional(),
    bodyColorOverride: ColorOverride_1.ColorOverrideSchema.optional(),
    multiInstance: zod_1.z
        .object({
        instanceId: zod_1.z.string(),
        displayModuleRef: zod_1.z.string(),
    })
        .optional(),
    customTypeName: zod_1.z.string().optional(),
});
class ModuleInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, rawOpts) {
        super(context);
        this.pinNets = new Map();
        const opts = (0, zod_partial_1.partialWithoutDefaults)(exports.ModuleSchema).parse(rawOpts);
        this.ref = opts.ref ?? '';
        this.footprintRef = opts.footprintRef ?? '';
        this.componentRef = opts.componentRef ?? '';
        this.center = opts.center ?? [0, 0];
        this.layer = opts.layer ?? 'F';
        this.transform = opts.transform ?? { angle: 0, mirrored: [false, false] };
        this.name = opts.name ?? '';
        this.fullModuleName = opts.fullModuleName;
        this.drawProperties = opts.drawProperties ?? {};
        this.metadata = opts.metadata;
        this.bodyColorOverride = opts.bodyColorOverride;
        this.customTypeName = opts.customTypeName;
        this.pinNets = new Map(Object.entries(opts.pinNets ?? {}).map(([pin, net]) => [pin, context.netRefCtx.existingOrNewRef(net)]));
    }
    getPinNet(pin) {
        return this.pinNets.get(pin);
    }
    setPinNet(pin, net) {
        this.pinNets.set(pin, this.context.netRefCtx.existingOrNewRef(net));
    }
    toJSON() {
        return {
            ref: this.ref,
            footprintRef: this.footprintRef,
            componentRef: this.componentRef,
            center: this.center,
            layer: this.layer,
            transform: this.transform,
            name: this.name,
            fullModuleName: this.fullModuleName,
            drawProperties: structuredClone(this.drawProperties),
            metadata: this.metadata,
            bodyColorOverride: this.bodyColorOverride,
            customTypeName: this.customTypeName,
            pinNets: Object.fromEntries(Array.from(this.pinNets).map(([pin, net]) => [pin, net.valueOf()])),
        };
    }
}
exports.ModuleInstance = ModuleInstance;
//# sourceMappingURL=Module.js.map